module.exports = __webpack_public_path__ + "static/media/Park-Place-ByLaws.49a23dc0.pdf";